// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#SubcomponentHighlight {
  background-color: #1ccf2b;
}

.headerfontsize {
  font-size: 20px;
}

::ng-deep mark {
  background: #076573;
  color: white;
  display: inline;
}

::ng-deep #sampleHiglights {
  background-color: cyan;
}

.handledHighlight {
  background-color: #d80210;
}

.card {
  background-color: white;
}

.btnspace {
  margin-left: 5px;
}

.lbltextwrap {
  white-space: pre-wrap;
}

.indivisualsegmentscroll {
  overflow: auto;
  background-color: white !important;
}

.indivisualsegmentnodatascroll {
  overflow: auto;
  height: 20px;
}

div.plus:before {
  content: "+";
  padding-right: 5px;
}

#truncate-text {
  display: block;
  white-space: nowrap;
  text-overflow: ellipsis;
}

div.minus:before {
  content: "-";
  padding-right: 5px;
}

.segment-item {
  white-space: nowrap; /* Prevent content from wrapping */
  text-overflow: ellipsis;
}

.parse-unit {
  overflow: scroll;
  white-space: nowrap;
  padding: 30px;
  margin-bottom: 30px;
  font-size: medium;
  font-weight: 200;
  line-height: 10px;
  color: inherit;
  background-color: #eeeeed;
  border-radius: 6px;
}

#container {
  overflow-x: scroll;
  white-space: nowrap;
}

#modal-content {
  overflow-x: scroll;
  white-space: nowrap;
}

.child {
  display: inline-block;
  overflow-x: hidden;
  overflow-y: auto;
  height: 51%;
}

.modal-body {
  height: 82vh;
  overflow-x: hidden;
  overflow-y: hidden;
}

.modal-footer {
  display: block;
}

#seg {
  border: 1px solid #2196f3;
}

#subc {
  border: 1px solid #2196f3;
}

.segmentfields-card {
  display: inline-block;
  width: 100%;
  overflow: auto;
}

.segmentcomponent-card {
  display: inline-block;
  width: 100%;
  overflow: auto;
}

.segmentsubcomponent-card {
  display: inline-block;
  width: 100%;
  overflow: auto;
}

.seletedsegmentfield {
  background-color: #17a0b4;
  color: #fff;
}

#hl7texteditor {
  height: 46% !important;
  border: 1px solid #2196f3;
  border-radius: 7px;
}

.note {
  color: #e90b0b;
  margin-left: 24px;
}

.sampleHiglight {
  background-color: #e90b0b !important;
}

*::-webkit-scrollbar {
  scrollbar-gutter: stable both-edges;
  overflow-y: scroll;
}

.white-text {
  color: white;
}

.HL7segmentHighlight {
  background-color: #17a0b4 !important; /* You can adjust the background color as needed */
}

*::-webkit-scrollbar-thumb {
  background-color: darkgrey;
  outline: 1px solid slategrey;
  border-radius: 5px;
}

div::-webkit-scrollbar-thumb {
  background-color: darkgrey;
  border-radius: 5px;
}

body::-webkit-scrollbar-thumb {
  background-color: darkgrey;
}

.displayName_ellipsis {
  max-width: 90%;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.breadcrumb .breadcrumbsucess {
  list-style: none;
  overflow: hidden;
  font: 18px Helvetica, Arial, Sans-Serif;
  margin-left: 0;
  padding: 0;
  flex-wrap: unset;
  overflow-x: auto;
  background-color: transparent;
  max-width: inherit;
}

.breadcrumb .breadcrumbsucess li {
  float: left;
}

.breadcrumb .breadcrumbsucess li a {
  color: white;
  text-decoration: none;
  padding: 5px 0 5px 55px;
  /* fallback color */
  background: hsl(180, 85%, 35%);
  position: relative;
  display: block;
  float: left;
  font-size: 12px;
}

.breadcrumb .breadcrumbsucess li a:after {
  content: " ";
  display: block;
  width: 0;
  height: 0;
  border-left: 12px solid #0da5a5;
  position: absolute;
  top: 50%;
  z-index: 2;
  margin-top: -12px;
  margin-left: 0px;
  left: 100%;
  border-top: 12px solid transparent;
  border-bottom: 12px solid transparent;
}

.breadcrumb .breadcrumbsucess li a:before {
  content: " ";
  display: block;
  width: 0;
  height: 0;
  position: absolute;
  top: 50%;
  margin-top: -12px;
  margin-left: 2px;
  left: 100%;
  border-top: 12px solid transparent;
  border-bottom: 12px solid transparent;
  border-left: 12px solid white;
  z-index: 1;
}

.breadcrumb .breadcrumbsucess li a:hover {
  background: hsl(180, 85%, 35%);
}

.breadcrumb .breadcrumbsucess li a:hover:after {
  border-left-color: hsl(180, 85%, 35%) !important;
}

.breadcrumb .breadcrumberror {
  list-style: none;
  overflow: hidden;
  font: 18px Helvetica, Arial, Sans-Serif;
  margin-left: 0;
  padding: 0;
  flex-wrap: unset;
  overflow-x: auto;
  background-color: transparent;
  max-width: inherit;
}

.breadcrumb .breadcrumberror li {
  float: left;
}

.breadcrumb .breadcrumberror li a {
  color: white;
  text-decoration: none;
  padding: 5px 0 5px 55px;
  background: rgb(233, 11, 11);
  position: relative;
  display: block;
  float: left;
  font-size: 12px;
}

.breadcrumb .breadcrumberror li a:after {
  content: " ";
  display: block;
  width: 0;
  height: 0;
  border-left: 12px solid #e90b0b;
  position: absolute;
  top: 50%;
  z-index: 2;
  margin-top: -12px;
  margin-left: 0px;
  left: 100%;
  border-top: 12px solid transparent;
  border-bottom: 12px solid transparent;
}

.breadcrumb .breadcrumberror li a:before {
  content: " ";
  display: block;
  width: 0;
  height: 0;
  position: absolute;
  top: 50%;
  margin-top: -12px;
  margin-left: 2px;
  left: 100%;
  border-top: 12px solid transparent;
  border-bottom: 12px solid transparent;
  border-left: 12px solid white;
  z-index: 1;
}

.breadcrumb .breadcrumberror li a:hover {
  background: rgb(233, 11, 11);
}

.breadcrumb .breadcrumberror li a:hover:after {
  border-left-color: rgb(233, 11, 11) !important;
}

.formcontrol {
  display: block;
  width: 100%;
  padding: 0.5rem 0.75rem;
  line-height: 1.5;
  color: #464a4c;
  background-color: #fff;
  background-image: none;
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
  border: 1px solidrgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  border-color: rgba(120, 130, 140, 0.2);
  border-radius: 0;
}

.segmentcard {
  position: relative;
  display: flex;
  flex-direction: initial;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
}

.list_card:hover {
  background-color: #cee4e8;
  cursor: pointer;
}

::-moz-scrollbar {
  background-color: #f1f1f1; /* Set the background color */
}

.highlighted-row {
  background-color: #d80210; /* Example background color */
  color: #fff; /* Example text color */
}

.iconpointer {
  cursor: pointer;
}

.highlighttext {
  color: red;
}

.highlighttext:hover {
  color: red !important;
}

.red-text {
  color: #e90b0b !important;
}

span title {
  font-size: 50px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/hl7viewer/hl7viewer.component.scss"],"names":[],"mappings":"AAIA;EAEE,yBAAA;AAJF;;AAOA;EACE,eAAA;AAJF;;AAMA;EACE,mBAAA;EACA,YAAA;EACA,eAAA;AAHF;;AAMA;EAEK,sBAAA;AAJL;;AAOA;EAEE,yBAAA;AALF;;AAOA;EACE,uBAAA;AAJF;;AAOA;EACE,gBAAA;AAJF;;AAOA;EACE,qBAAA;AAJF;;AAOA;EACE,cAAA;EACA,kCAAA;AAJF;;AAOA;EACE,cAAA;EACA,YAAA;AAJF;;AAOA;EACE,YAAA;EACA,kBAAA;AAJF;;AAMA;EAEE,cAAA;EACE,mBAAA;EAEA,uBAAA;AALJ;;AAQA;EACE,YAAA;EACA,kBAAA;AALF;;AAOA;EAEE,mBAAA,EAAA,kCAAA;EAEA,uBAAA;AANF;;AASA;EACE,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,yBAAA;EAGA,kBAAA;AANF;;AASA;EACE,kBAAA;EACA,mBAAA;AANF;;AASA;EACE,kBAAA;EACA,mBAAA;AANF;;AAWA;EACE,qBAAA;EAEA,kBAAA;EACA,gBAAA;EACA,WAAA;AATF;;AAWA;EAEI,YAAA;EACA,kBAAA;EACA,kBAAA;AATJ;;AAYA;EAEE,cAAA;AAVF;;AAaA;EACE,yBAAA;AAVF;;AAYA;EACE,yBAAA;AATF;;AAYA;EACE,qBAAA;EAEA,WAAA;EAEA,cAAA;AAXF;;AAcA;EACE,qBAAA;EAEA,WAAA;EAEA,cAAA;AAbF;;AAgBA;EACE,qBAAA;EAEA,WAAA;EAEA,cAAA;AAfF;;AAmBA;EACE,yBAAA;EACA,WAAA;AAhBF;;AAmBA;EACE,sBAAA;EACA,yBAAA;EACA,kBAAA;AAhBF;;AAoBA;EAEE,cAAA;EACA,iBAAA;AAlBF;;AAoBA;EAEE,oCAAA;AAlBF;;AAqBA;EACE,mCAAA;EACA,kBAAA;AAlBF;;AAoBA;EACE,YAAA;AAjBF;;AAmBA;EACE,oCAAA,EAAA,kDAAA;AAhBF;;AAkBA;EACE,0BAAA;EACA,4BAAA;EACA,kBAAA;AAfF;;AAkBA;EACE,0BAAA;EACA,kBAAA;AAfF;;AAoBA;EACE,0BAAA;AAjBF;;AAqBA;EACE,cAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAlBF;;AAqBA;EACE,gBAAA;EACA,gBAAA;EACA,uCACE;EAGF,cAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;EACA,kBAAA;AArBF;;AAwBA;EACE,WAAA;AArBF;;AAwBA;EACE,YAAA;EACA,qBAAA;EACA,uBAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,eAAA;AArBF;;AAwBA;EACE,YAAA;EACA,cAAA;EACA,QAAA;EACA,SAAA;EACA,+BAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,iBAAA;EACA,gBAAA;EACA,UAAA;EACA,kCAAA;EACA,qCAAA;AArBF;;AAwBA;EACE,YAAA;EACA,cAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;EACA,gBAAA;EACA,UAAA;EACA,kCAAA;EACA,qCAAA;EACA,6BAAA;EACA,UAAA;AArBF;;AAwBA;EACE,8BAAA;AArBF;;AAwBA;EACE,gDAAA;AArBF;;AAyBA;EACE,gBAAA;EACA,gBAAA;EACA,uCACE;EAGF,cAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;EACA,kBAAA;AAzBF;;AA4BA;EACE,WAAA;AAzBF;;AA4BA;EACE,YAAA;EACA,qBAAA;EACA,uBAAA;EACA,4BAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,eAAA;AAzBF;;AA4BA;EACE,YAAA;EACA,cAAA;EACA,QAAA;EACA,SAAA;EACA,+BAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,iBAAA;EACA,gBAAA;EACA,UAAA;EACA,kCAAA;EACA,qCAAA;AAzBF;;AA4BA;EACE,YAAA;EACA,cAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;EACA,gBAAA;EACA,UAAA;EACA,kCAAA;EACA,qCAAA;EACA,6BAAA;EACA,UAAA;AAzBF;;AA4BA;EACE,4BAAA;AAzBF;;AA4BA;EACE,8CAAA;AAzBF;;AA6BA;EACE,cAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,sBAAA;EACA,oCAAA;EACA,4BAAA;EACA,oCAAA;EACA,sBAAA;EACA,wEACE;EAEF,sCAAA;EACA,gBAAA;AA5BF;;AA+BA;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,sCAAA;EACA,sBAAA;AA5BF;;AA+BA;EACE,yBAAA;EACA,eAAA;AA5BF;;AA8BA;EACE,yBAAA,EAAA,6BAAA;AA3BF;;AAuCA;EACE,yBAAA,EAAA,6BAAA;EACA,WAAA,EAAA,uBAAA;AApCF;;AAuDA;EACE,eAAA;AApDF;;AA8DA;EACE,UAAA;AA3DF;;AA8DA;EACE,qBAAA;AA3DF;;AA6DA;EAEE,yBAAA;AA3DF;;AA8DA;EACE,0BAAA;AA3DF","sourcesContent":["// .mainheader {\r\n//   background-color: #3697dc;\r\n//   color: white;\r\n// }\r\n#SubcomponentHighlight\r\n{\r\n  background-color: #1ccf2b;\r\n}\r\n\r\n.headerfontsize {\r\n  font-size: 20px;\r\n}\r\n::ng-deep mark {\r\n  background: #076573;\r\n  color: white;\r\n  display: inline;\r\n}\r\n\r\n::ng-deep #sampleHiglights\r\n{\r\n     background-color: cyan;\r\n}\r\n\r\n.handledHighlight\r\n{\r\n  background-color: #d80210;\r\n}\r\n.card {\r\n  background-color: white;\r\n}\r\n\r\n.btnspace {\r\n  margin-left: 5px;\r\n}\r\n\r\n.lbltextwrap {\r\n  white-space: pre-wrap;\r\n}\r\n\r\n.indivisualsegmentscroll {\r\n  overflow: auto;\r\n  background-color: white !important;\r\n}\r\n\r\n.indivisualsegmentnodatascroll {\r\n  overflow: auto;\r\n  height: 20px;\r\n}\r\n\r\ndiv.plus:before {\r\n  content: \"+\";\r\n  padding-right: 5px;\r\n}\r\n#truncate-text\r\n{\r\n  display: block;\r\n    white-space: nowrap;\r\n\r\n    text-overflow: ellipsis;\r\n}\r\n\r\ndiv.minus:before {\r\n  content: \"-\";\r\n  padding-right: 5px;\r\n}\r\n.segment-item\r\n{\r\n  white-space: nowrap; /* Prevent content from wrapping */\r\n\r\n  text-overflow: ellipsis;\r\n\r\n}\r\n.parse-unit {\r\n  overflow: scroll;\r\n  white-space: nowrap;\r\n  padding: 30px;\r\n  margin-bottom: 30px;\r\n  font-size: medium;\r\n  font-weight: 200;\r\n  line-height: 10px;\r\n  color: inherit;\r\n  background-color: #eeeeed;\r\n  -webkit-border-radius: 6px;\r\n  -moz-border-radius: 6px;\r\n  border-radius: 6px;\r\n}\r\n\r\n#container {\r\n  overflow-x: scroll;\r\n  white-space: nowrap;\r\n}\r\n\r\n#modal-content {\r\n  overflow-x: scroll;\r\n  white-space: nowrap;\r\n}\r\n\r\n\r\n\r\n.child {\r\n  display: inline-block;\r\n\r\n  overflow-x: hidden;\r\n  overflow-y: auto;\r\n  height: 51%;\r\n}\r\n.modal-body{\r\n\r\n    height: 82vh;\r\n    overflow-x: hidden;\r\n    overflow-y: hidden;\r\n\r\n}\r\n.modal-footer{\r\n\r\n  display: block;\r\n\r\n}\r\n#seg{\r\n  border: 1px solid #2196f3\r\n}\r\n#subc{\r\n  border: 1px solid #2196f3\r\n}\r\n\r\n.segmentfields-card {\r\n  display: inline-block;\r\n  // width: 670px;\r\n  width: 100%;\r\n\r\n  overflow: auto;\r\n}\r\n\r\n.segmentcomponent-card {\r\n  display: inline-block;\r\n  // width: 670px;\r\n  width: 100%;\r\n\r\n  overflow: auto;\r\n}\r\n\r\n.segmentsubcomponent-card {\r\n  display: inline-block;\r\n  // width: 670px;\r\n  width: 100%;\r\n\r\n  overflow: auto;\r\n\r\n}\r\n\r\n.seletedsegmentfield {\r\n  background-color: #17a0b4 ;\r\n  color: #fff;\r\n}\r\n\r\n#hl7texteditor {\r\n  height: 46% !important;\r\n  border: 1px solid #2196f3;;\r\n  border-radius: 7px;\r\n\r\n}\r\n\r\n.note\r\n{\r\n  color: #e90b0b;\r\n  margin-left: 24px;\r\n}\r\n.sampleHiglight\r\n{\r\n  background-color: #e90b0b !important;\r\n}\r\n\r\n*::-webkit-scrollbar {\r\n  scrollbar-gutter: stable both-edges;\r\n  overflow-y: scroll;\r\n}\r\n.white-text {\r\n  color: white;\r\n}\r\n.HL7segmentHighlight {\r\n  background-color: #17a0b4 !important; /* You can adjust the background color as needed */\r\n}\r\n*::-webkit-scrollbar-thumb {\r\n  background-color: darkgrey;\r\n  outline: 1px solid slategrey;\r\n  border-radius: 5px;\r\n}\r\n\r\ndiv::-webkit-scrollbar-thumb {\r\n  background-color: darkgrey;\r\n  border-radius: 5px;\r\n\r\n\r\n}\r\n\r\nbody::-webkit-scrollbar-thumb {\r\n  background-color: darkgrey;\r\n\r\n}\r\n\r\n.displayName_ellipsis {\r\n  max-width: 90%;\r\n  display: inline-block;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.breadcrumb .breadcrumbsucess {\r\n  list-style: none;\r\n  overflow: hidden;\r\n  font:\r\n    18px Helvetica,\r\n    Arial,\r\n    Sans-Serif;\r\n  margin-left: 0;\r\n  padding: 0;\r\n  flex-wrap: unset;\r\n  overflow-x: auto;\r\n  background-color: transparent;\r\n  max-width: inherit;\r\n}\r\n\r\n.breadcrumb .breadcrumbsucess li {\r\n  float: left;\r\n}\r\n\r\n.breadcrumb .breadcrumbsucess li a {\r\n  color: white;\r\n  text-decoration: none;\r\n  padding: 5px 0 5px 55px;\r\n  /* fallback color */\r\n  background: hsl(180deg 85% 35%);\r\n  position: relative;\r\n  display: block;\r\n  float: left;\r\n  font-size: 12px;\r\n}\r\n\r\n.breadcrumb .breadcrumbsucess li a:after {\r\n  content: \" \";\r\n  display: block;\r\n  width: 0;\r\n  height: 0;\r\n  border-left: 12px solid #0da5a5;\r\n  position: absolute;\r\n  top: 50%;\r\n  z-index: 2;\r\n  margin-top: -12px;\r\n  margin-left: 0px;\r\n  left: 100%;\r\n  border-top: 12px solid transparent;\r\n  border-bottom: 12px solid transparent;\r\n}\r\n\r\n.breadcrumb .breadcrumbsucess li a:before {\r\n  content: \" \";\r\n  display: block;\r\n  width: 0;\r\n  height: 0;\r\n  position: absolute;\r\n  top: 50%;\r\n  margin-top: -12px;\r\n  margin-left: 2px;\r\n  left: 100%;\r\n  border-top: 12px solid transparent;\r\n  border-bottom: 12px solid transparent;\r\n  border-left: 12px solid white;\r\n  z-index: 1;\r\n}\r\n\r\n.breadcrumb .breadcrumbsucess li a:hover {\r\n  background: hsl(180deg 85% 35%);\r\n}\r\n\r\n.breadcrumb .breadcrumbsucess li a:hover:after {\r\n  border-left-color: hsl(180deg 85% 35%) !important;\r\n}\r\n\r\n// failure\r\n.breadcrumb .breadcrumberror {\r\n  list-style: none;\r\n  overflow: hidden;\r\n  font:\r\n    18px Helvetica,\r\n    Arial,\r\n    Sans-Serif;\r\n  margin-left: 0;\r\n  padding: 0;\r\n  flex-wrap: unset;\r\n  overflow-x: auto;\r\n  background-color: transparent;\r\n  max-width: inherit;\r\n}\r\n\r\n.breadcrumb .breadcrumberror li {\r\n  float: left;\r\n}\r\n\r\n.breadcrumb .breadcrumberror li a {\r\n  color: white;\r\n  text-decoration: none;\r\n  padding: 5px 0 5px 55px;\r\n  background: rgb(233, 11, 11);\r\n  position: relative;\r\n  display: block;\r\n  float: left;\r\n  font-size: 12px;\r\n}\r\n\r\n.breadcrumb .breadcrumberror li a:after {\r\n  content: \" \";\r\n  display: block;\r\n  width: 0;\r\n  height: 0;\r\n  border-left: 12px solid #e90b0b;\r\n  position: absolute;\r\n  top: 50%;\r\n  z-index: 2;\r\n  margin-top: -12px;\r\n  margin-left: 0px;\r\n  left: 100%;\r\n  border-top: 12px solid transparent;\r\n  border-bottom: 12px solid transparent;\r\n}\r\n\r\n.breadcrumb .breadcrumberror li a:before {\r\n  content: \" \";\r\n  display: block;\r\n  width: 0;\r\n  height: 0;\r\n  position: absolute;\r\n  top: 50%;\r\n  margin-top: -12px;\r\n  margin-left: 2px;\r\n  left: 100%;\r\n  border-top: 12px solid transparent;\r\n  border-bottom: 12px solid transparent;\r\n  border-left: 12px solid white;\r\n  z-index: 1;\r\n}\r\n\r\n.breadcrumb .breadcrumberror li a:hover {\r\n  background: rgb(233, 11, 11);\r\n}\r\n\r\n.breadcrumb .breadcrumberror li a:hover:after {\r\n  border-left-color: rgb(233, 11, 11) !important;\r\n}\r\n\r\n\r\n.formcontrol {\r\n  display: block;\r\n  width: 100%;\r\n  padding: 0.5rem 0.75rem;\r\n  line-height: 1.5;\r\n  color: #464a4c;\r\n  background-color: #fff;\r\n  background-image: none;\r\n  -webkit-background-clip: padding-box;\r\n  background-clip: padding-box;\r\n  border: 1px solidrgba(0, 0, 0, 0.15);\r\n  border-radius: 0.25rem;\r\n  transition:\r\n    border-color ease-in-out 0.15s,\r\n    box-shadow ease-in-out 0.15s;\r\n  border-color: rgba(120, 130, 140, 0.2);\r\n  border-radius: 0;\r\n}\r\n\r\n.segmentcard {\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: initial;\r\n  background-color: #fff;\r\n  border: 1px solid rgba(0, 0, 0, 0.125);\r\n  border-radius: 0.25rem;\r\n}\r\n\r\n.list_card:hover {\r\n  background-color:  #cee4e8 ;;\r\n  cursor: pointer;\r\n}\r\n::-moz-scrollbar {\r\n  background-color: #f1f1f1; /* Set the background color */\r\n}\r\n\r\n// ::selection {\r\n//   // background-color: #ea5c80;\r\n//   // color: black;\r\n//   // background-color: #464a4cc7;\r\n//   // color: #fff;\r\n//   background-color: #0275d8;\r\n//   color: #fff;\r\n// }\r\n\r\n.highlighted-row {\r\n  background-color: #d80210; /* Example background color */\r\n  color: #fff; /* Example text color */\r\n}\r\n// ::ng-deep #highlightText {\r\n//   background: cyan;\r\n// }\r\n\r\n// mark {\r\n//   border-radius: 3px;\r\n//   color: transparent;\r\n//   background-color: #d01313;\r\n// }\r\n// CSS\r\n\r\n// textarea::selection {\r\n//   background-color: #2612d6;\r\n//   color: #fff;\r\n// }\r\n\r\n\r\n.iconpointer {\r\n  cursor: pointer;\r\n}\r\n\r\n// i:hover {\r\n//   color: orange !important;\r\n// }\r\n.TextHighlight\r\n{\r\n\r\n}\r\n.highlighttext {\r\n  color: red;\r\n}\r\n\r\n.highlighttext:hover {\r\n  color: red !important;\r\n}\r\n.red-text\r\n{\r\n  color: #e90b0b !important;\r\n}\r\n\r\nspan title {\r\n  font-size: 50px !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
